import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const AttributionContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${theme["--ll-spacing-small"]};
  background-color: ${theme["--ll-color-background"]};
`;
